import { Component, OnInit } from '@angular/core';
import { IktatgatoService } from '../iktatgato.service';
import { DataService } from '../../data.service';

/**
 *  Iktatókönyvek. Egy intézményben TÖBB könyv is nyitható (pl. tanügyi és gazdasági),
 *  a könyv jele az iktatószám része. Zárt könyvbe nem lehet iktatni.
 */
@Component({
  selector: 'app-ikt-konyvek',
  templateUrl: './konyvek.component.html',
  styleUrls: ['../iktatgato-layout/iktatgato-layout.component.scss'],
})
export class IktKonyvekComponent implements OnInit {
  konyvek: any[] = [];
  uj: any = { nev: '', jel: '', ev: new Date().getFullYear(), leiras: '' };
  ujForm = false;

  constructor(private ikt: IktatgatoService, private data: DataService) {}

  async ngOnInit() { await this.betolt(); }

  async betolt() {
    try { this.konyvek = await this.ikt.konyvek(); }
    catch (e: any) { this.data.sendToast(e?.error?.error || 'Nem sikerült betölteni a könyveket.', 'error'); }
  }

  async letrehoz() {
    if (!this.uj.nev?.trim()) { this.data.sendToast('Adj nevet az iktatókönyvnek.', 'warning'); return; }
    try {
      await this.ikt.konyvLetrehoz(this.uj);
      this.data.sendToast('Iktatókönyv megnyitva.');
      this.ujForm = false;
      this.uj = { nev: '', jel: '', ev: this.uj.ev, leiras: '' };
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A létrehozás nem sikerült.', 'error');
    }
  }

  /** A jel csak üres könyvben javítható – a backend is ellenőrzi. */
  async jelJavitas(k: any) {
    const jel = prompt(`A(z) ${k.nev} könyv új jele:`, k.jel || '');
    if (jel === null || !jel.trim()) return;
    try {
      await this.ikt.konyvMuvelet(k.id, { muvelet: 'jel', jel });
      this.data.sendToast('A könyv jele módosult.');
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A módosítás nem sikerült.', 'error');
    }
  }

  async muvelet(k: any, muvelet: string, kerdes: string) {
    if (!confirm(kerdes)) return;
    try {
      await this.ikt.konyvMuvelet(k.id, { muvelet });
      this.data.sendToast('Kész.');
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A művelet nem sikerült.', 'error');
    }
  }
}
